module.exports = __webpack_public_path__ + "assets/dragdrop.db47c795.svg";